import { useLocation } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { AuthContext } from '../contexts/auth';

export const RouteTracker = () => {
  const location = useLocation();
  const { userId, userRank, userType } = useContext(AuthContext);

  useEffect(() => {
    window.dataLayer.push({
      event: 'page_view',
      page_path: location.pathname,
      page_location: window.location.href,
      user_id: userId,
      user_rank: userRank,
      user_type: userType
    });
  }, [location.pathname, userId, userRank, userType]);

  return null;
};
